import { Modal } from 'antd';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import RegisterForm from '../../Auth/RegisterForm';

const AddUser: React.FC<any> = (props) => {
  const { handleAddModa, openAddModal, getList } = props;
  return (
    <>
      <Modal
        open={openAddModal}
        destroyOnClose
        width={800}
        onCancel={handleAddModa}
        closeIcon={<FontAwesomeIcon icon={faTimes} />}
        footer={false}
        className="addModal"
        title={`Add User`}
      >
        <RegisterForm isAdd={true} handleAddModa={handleAddModa} getList={getList} />
      </Modal>
    </>
  );
};

export default AddUser;
